import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { StockReceiptsListPage } from '@/features/stock-receipts/pages/stock-receipts-list-page'
import { stockReceiptsGlobalListQuery } from '@/features/stock-receipts/queries/stock-receipt-queries'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/stock-receipts/')({
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(stockReceiptsGlobalListQuery()),
      queryClient.ensureQueryData(projectsListQuery()),
      queryClient.ensureQueryData(warehousesListQuery()),
    ]),
  component: StockReceiptsListPage,
  staticData: { crumb: messages.crumbs.stockReceipts },
})
